
import { mapState } from 'vuex'

export default {
  name: 'ProfileShoppingList',

  async asyncData({ store }) {
    await store.dispatch('shopping-lists/all')
  },

  head() {
    return {
      title: this.$t('my-shopping-lists'),
    }
  },

  computed: { ...mapState('shopping-lists', ['shoppingLists']) },
}
